export default __webpack_public_path__ + "static/media/russian poker-02.bc7ec880.png";